import activityPng from "@assets/images/shareroom/activity.png";
import calendarPng from "@assets/images/shareroom/calendar.png";
import dashboardPng from "@assets/images/shareroom/dashboard.png";
import livePng from "@assets/images/shareroom/live.png";
import workspacesPng from "@assets/images/shareroom/workspaces.png";

export const SHAREROOM_GUIDE_INFOS = {
	DASHBOARD: dashboardPng,
	ACTIVITY: activityPng,
	LIVE: livePng,
	WORKSPACES: workspacesPng,
	CALENDAR: calendarPng,
} as const;
